import { Box, Divider, Flex, Paper } from '@shared/components';

import { QBankStructureSettingHeader, QBankStructureSettingMemberList } from './_containers';

export default function QBankStructureSettingPage() {
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        p: theme.spacing(6),
        flex: 1,
      })}
    >
      <Paper
        sx={(theme) => ({
          flexGrow: 1,
          borderRadius: theme.shape.rounded(2),
        })}
      >
        <Flex sx={{ width: '100%', flexDirection: 'column', minHeight: '100%' }}>
          <QBankStructureSettingHeader />
          <Divider />
          <Box
            sx={(theme) => ({
              p: theme.spacing(6),
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
            })}
          >
            <QBankStructureSettingMemberList />
          </Box>
        </Flex>
      </Paper>
    </Flex>
  );
}
